export enum FolderUploadType {
  cctv = 'cctv',
  deviceBackup = 'deviceBackup',
  generalContent = 'generalContent'
}